import { Component, Inject, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MAT_DIALOG_DATA, MatDialogRef, MatDialogModule } from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { FormsModule } from '@angular/forms';

import type { Group } from '@models/group.interface';

export interface GroupSelectDialogData {
  groups: Group[];
  chair?: any;
}

export interface GroupSelectDialogResult {
  groupId: string;
  chairNumber: string;
}

@Component({
  selector: 'app-group-select-dialog',
  standalone: true,
  imports: [
    CommonModule,
    MatDialogModule,
    MatButtonModule,
    MatIconModule,
    MatInputModule,
    FormsModule
  ],
  templateUrl: './group-select-dialog.component.html',
  styleUrls: ['./group-select-dialog.component.scss']
})
export class GroupSelectDialogComponent implements OnInit {
  selectedGroupId: string = '';
  chairNumber: string = '';
  isSingleGroup: boolean = false;

  constructor(
    public dialogRef: MatDialogRef<GroupSelectDialogComponent, GroupSelectDialogResult>,
    @Inject(MAT_DIALOG_DATA) public data: GroupSelectDialogData
  ) {}

  ngOnInit(): void {
    this.isSingleGroup = this.data.groups.length === 1;

    if (this.isSingleGroup) {
      // Automatski odaberi jedinu grupu
      this.selectedGroupId = this.data.groups[0]?.id || '';
    }
  }

  selectGroup(groupId: string): void {
    this.selectedGroupId = groupId;
  }

  confirm(): void {
    if (!this.selectedGroupId) return;
    this.dialogRef.close({
      groupId: this.selectedGroupId,
      chairNumber: this.chairNumber.trim()
    });
  }

  cancel(): void {
    this.dialogRef.close();
  }

  getGroupChairCount(groupId: string): number {
    const group = this.data.groups.find(g => g.id === groupId);
    return group?.sunbeds.length || 0;
  }

  get canConfirm(): boolean {
    return !!this.selectedGroupId && this.chairNumber.trim().length > 0;
  }
}
